document.addEventListener('turbolinks:load', function(event) { 
  document.querySelector('.pref_selector') && [...document.querySelectorAll('.pref_selector')].forEach(function(elm) {
    elm.addEventListener('change', function(e) {
      var options = this.querySelectorAll('option');
      var prefCd = options[this.selectedIndex].value; 
      var target = '#' + this.getAttribute('data-target');

      document.querySelector(target).innerHTML = '';
      var optionElm = document.createElement('option');
      var txtElm = document.createTextNode('選択してください');
      optionElm.appendChild(txtElm);
      document.querySelector(target).appendChild(optionElm);

      [...document.querySelectorAll('#contest_hidden_shop_id option')].forEach(function(elm) {
        if (elm.getAttribute('data-pref') == prefCd || prefCd == '') {
          document.querySelector(target).appendChild(elm.cloneNode(true));
        }
      });
    });
  });
  document.querySelector('.event_delete') && [...document.querySelectorAll('.event_delete')].forEach(function(elm) {
    elm.addEventListener('click', function(e) {
      e.preventDefault();
      var path = this.getAttribute('data-path');
      var name = this.getAttribute('data-name');

      document.querySelector('#modal_delete').classList.add('open');
      document.querySelector('#modal_delete p.delete_contents_name').innerText = name;
      document.querySelector('#modal_delete a.link_submit').href = path;
    });
  });
  document.querySelector('.event_close') && [...document.querySelectorAll('.event_close')].forEach(function(elm) {
    elm.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('#modal_delete').classList.remove('open');
    });
  });

  document.querySelector('.event_select_chain') && [...document.querySelectorAll('.event_select_chain')].forEach(function(elm) {
    elm.addEventListener('change', function(e) {
      var options = this.querySelectorAll('option');
      var chainCd = options[this.selectedIndex].value; 

      [...document.querySelectorAll('.contest_list_content .contest_list_item_block')].forEach(function(elm) {
        if (elm.getAttribute('data-chain-id') == chainCd || chainCd == '') {
          elm.style.display = 'block';
        } else {
          elm.style.display = 'none';
        }
      });
    });
  });
});
